module.exports = __webpack_public_path__ + "static/images/tag.e21c92c4744bba10da2b87acbd8cb27f.svg";